import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8100b0a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-and-buttons" }
const _hoisted_2 = { class: "card-frame" }
const _hoisted_3 = { class: "buttons" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]

import { computed, CSSProperties, onMounted, ref } from 'vue'
import { useStore } from 'vuex'
import QuestionCard from '@/components/QuestionCard.vue'
import ResultCard from '@/components/ResultCard.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Cards',
  setup(__props) {

const store = useStore()

const areButtonsDisabled = ref(true)
const fadeout = ref(false)
const fadein = ref(false)

const isLeftFullBg = computed(() => store.state.swipeState === 'left')
const isRightFullBg = computed(() => store.state.swipeState === 'right')
const buttonStyle = computed((): CSSProperties => {
  if (!areButtonsDisabled.value) {
    return {}
  }
  return { cursor: 'pointer', pointerEvents: 'none' }
})

const onClick = (left: boolean) => {
  if (areButtonsDisabled.value) {
    return
  }
  areButtonsDisabled.value = true
  store.commit(left ? 'clickLeft' : 'clickRight')
}
store.subscribe((mutation) => {
  if (mutation.type === 'answer') {
    areButtonsDisabled.value = true
    fadeout.value = true
  }
})
store.subscribeAction((action) => {
  if (action.type === 'confirm') {
    fadein.value = true
    fadeout.value = false
    setTimeout(() => {
      areButtonsDisabled.value = false
      fadein.value = false
    }, 500)
  }
})
onMounted(() => {
  setTimeout(() => (areButtonsDisabled.value = false), 2000)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(QuestionCard),
      _createVNode(ResultCard)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: _normalizeClass(["no button transButton", { fullBackground: _unref(isLeftFullBg), fadeout: fadeout.value, fadein: fadein.value }]),
        style: _normalizeStyle(_unref(buttonStyle)),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (onClick(true))),
        innerHTML: _unref(store).getters.question.options[0]
      }, null, 14, _hoisted_4),
      _createElementVNode("div", {
        class: _normalizeClass(["yes button transButton", { fullBackground: _unref(isRightFullBg), fadeout: fadeout.value, fadein: fadein.value }]),
        style: _normalizeStyle(_unref(buttonStyle)),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (onClick(false))),
        innerHTML: _unref(store).getters.question.options[1]
      }, null, 14, _hoisted_5)
    ])
  ]))
}
}

})